import { useMutation, UseMutationResult, useQueryClient } from "react-query";
import { useAuth } from "../../sdk/hooks";
import * as scheduleApi from "../../sdk/utils/api/price-change-schedule";

export const useCancelSchedule = (
    invalidQueryKeys: string | string[]
): UseMutationResult<void, unknown, string> => {
    const { token } = useAuth();
    const queryClient = useQueryClient();

    return useMutation<void, unknown, string>(
        async (scheduleId: string) => {
            if (!token) throw new Error("Not authenticated");
            return await scheduleApi.cancelSchedule(token, scheduleId);
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries(invalidQueryKeys);
            },
        }
    );
};
